import PasswordReset from "../components/PasswordReset/PasswordReset";
import useNavigation from "../hooks/navigation";
import { useRequestPasswordReset } from "../hooks/useAuth";
import { useEmailStore } from "../stores/emailStore";

const PasswordResetContainer = () => {
  const navigation = useNavigation();

  const {
    error: requestPasswordResetError,
    isSuccess: isRequestResetPasswordSuccess,
    isPending: isRequestResetPasswordPending,
    mutate: mutateRequestResetPassword,
    reset: resetRequestPasswordReset,
  } = useRequestPasswordReset();

  const submit = (email: string, captcha: string) => {
    mutateRequestResetPassword({ email, captcha });
  };

  const { email } = useEmailStore();

  return (
    <PasswordReset
      onSubmit={submit}
      onReset={resetRequestPasswordReset}
      onBackClick={(email) => {
        navigation.goToSignIn({ email });
      }}
      inProgress={isRequestResetPasswordPending}
      submitSuccess={isRequestResetPasswordSuccess}
      submitError={requestPasswordResetError}
      initialEmail={email}
    />
  );
};

export default PasswordResetContainer;
